// extracted by mini-css-extract-plugin
module.exports = {"chatBubble":"ChatBubble_chatBubble__HEE7h","notificationBadge":"ChatBubble_notificationBadge__LHZD7"};